import { forwardRef } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerProps,
  useDrawer,
  useDrawerInstance,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { PreviewYaml } from 'components/code';
import { KeyVal } from 'core/forms';

type WorkloadAutoscalerConfigSubdrawerProps = { config: KeyVal } & DrawerProps;

const WorkloadAutoscalerConfigSubdrawer = forwardRef<
  HTMLDivElement,
  WorkloadAutoscalerConfigSubdrawerProps
>(({ config, ...props }: WorkloadAutoscalerConfigSubdrawerProps, ref) => {
  return (
    <Drawer
      ref={ref}
      color="secondary"
      testId="workload-autoscaler-drawer"
      size="small"
      {...props}
    >
      <DrawerHeader />
      <DrawerBody>
        <DrawerContent>
          <Stack gap={16} onClick={(e) => e.stopPropagation()}>
            <Typography variant="h5">{config.key}</Typography>

            <Box data-testid="workload-autoscaler-config">
              <PreviewYaml
                data={config.value}
                size="md"
                rootSx={{
                  backgroundColor: tokens.theme.bg.structural.code,
                }}
                containerSx={{
                  padding: '4px 8px',
                }}
              />
            </Box>
          </Stack>
        </DrawerContent>
      </DrawerBody>
    </Drawer>
  );
});

WorkloadAutoscalerConfigSubdrawer.displayName =
  'WorkloadAutoscalerConfigSubdrawer';

export const useWorkloadAutoscalerConfigSubdrawer = () => {
  const { open } = useDrawer();
  const instance = useDrawerInstance();

  return {
    openWorkloadAutoscalerConfigSubdrawer: (props: { config: KeyVal }) => {
      open({
        component: WorkloadAutoscalerConfigSubdrawer,
        props,
        options: instance?.id ? { parentId: instance.id } : undefined,
      });
    },
  };
};
